/**
 * YouTube IFRAME API
 * @type {null}
 */
/** @var callable youTubeIframeAPIReadyCallback A callback to called once the YouTube API is ready */
var youTubeIframeAPIReadyCallback = null;
/** @var bool isYouTubeIframeAPIReady = false */
var isYouTubeIframeAPIReady = false;

/**
 * Call callback when YouTube IFRAME API is available
 * @param {function} callback
 */
function whenYouTubeIframeAPIReady(callback) {
	if (typeof(callback) != 'function') {
		console.log('whenYouTubeIframeAPIRead requires a callback');
		return;
	}

	youTubeIframeAPIReadyCallback = callback;
	/**
	 * If the YouTube IFRAME API has already been
	 * activated then call callback immediately
	 **/
	if (isYouTubeIframeAPIReady) {
		callback.call();
	}
}

/**
 * Handle YouTube IFRAME API default function
 * @link https://developers.google.com/youtube/iframe_api_reference
 */
function onYouTubeIframeAPIReady() {
	isYouTubeIframeAPIReady = true;
	/**
	 * If a callback has already been defined then call it
	 */
	if (youTubeIframeAPIReadyCallback != null) {
		youTubeIframeAPIReadyCallback.call();
	}
}

var YouTubeVideoManager = function() {
	this.videos = {};
};

var youTubeVideoManagerInstance = null;
YouTubeVideoManager.instance = function() {
	if (!youTubeVideoManagerInstance) youTubeVideoManagerInstance = new YouTubeVideoManager();
	return youTubeVideoManagerInstance;
}

/**
 * Enumerator for the various states that a video might be in
 * @type {{UNINITIATED: number, LOADING: number, LOADED: number}}
 */
YouTubeVideoManager.VideoState = {
	UNINITIATED: -1,
	LOADING: 0,
	LOADED: 1
};

/**
 * Instantiate a video using its IFRAME id
 * @param {string} iframeVideoId
 * @returns {YouTubeVideoManager.Video}
 */
YouTubeVideoManager.prototype.video = function(iframeVideoId) {
	var self = this;

	// Create new instance of video, if it has not already been created
	if (typeof(this.videos[iframeVideoId]) == 'undefined') {
		this.videos[iframeVideoId] = new YouTubeVideoManager.Video(iframeVideoId);

		whenYouTubeIframeAPIReady(function () {
			self.videos[iframeVideoId]._init();
		});
	}

	return this.videos[iframeVideoId];
};

/**
 * Pause playback for all videos under management
 */
YouTubeVideoManager.prototype.pauseAll = function() {
	for (var i in this.videos) {
		this.videos[i].pause();
	}
}
/**
 * An instance of a Video that has been added to YouTubeVideoManager
 * @param {string} iframeVideoId
 * @constructor
 */
YouTubeVideoManager.Video = function(iframeVideoId) {
	this.iframeVideoId = iframeVideoId;
	this.state = YouTubeVideoManager.VideoState.LOADING;
	this.player = null;
	this.handlers = {};
};

/**
 * Initializes a YouTube Player, called once the YouTube Iframe API has been initialized
 * @private
 */
YouTubeVideoManager.Video.prototype._init = function() {
	this.player = new YT.Player(this.iframeVideoId, {
		events: {
			'onReady': this._createHandler('onReady').bind(this),
			'onStateChange': this._createHandler('onStateChange').bind(this)
		}
	});
}

/**
 * Sets a handler for the "onReady" event
 * @param {function} handler
 * @returns {YouTubeVideoManager.Video}
 */
YouTubeVideoManager.Video.prototype.onReady = function(handler) {
	this.handlers['onReady'] = handler;
	return this;
}

/**
 * Sets a handler for the onStateChange event
 * @param {function} handler
 * @returns {YouTubeVideoManager.Video}
 */
YouTubeVideoManager.Video.prototype.onStateChange = function(handler) {
	this.handlers['onStateChange'] = handler;
	return this;
}

/**
 * Starts video playback
 */
YouTubeVideoManager.Video.prototype.play = function() {
	if (!this.player) return;

	this.player.playVideo();
}

/**
 * Stops video playback
 */
YouTubeVideoManager.Video.prototype.stop = function() {
	if (!this.player) return;

	this.player.stopVideo();
}

/**
 * Pauses video playback
 */
YouTubeVideoManager.Video.prototype.pause = function() {
	if (!this.player) return;

	this.player.pauseVideo();
}

YouTubeVideoManager.Video.prototype._createHandler = function(handlerName) {
	return function(ev) {
		// Bail if handler is not defined
		if (typeof(this.handlers[handlerName]) != 'function') return;

		this.handlers[handlerName].call(this, ev);
	};
}